module.exports = __webpack_public_path__ + "img/feedback3-2.ec1ea9d7.jpg";